import { makeStyles, shorthands } from '@fluentui/react-components';

export const useFilterStyles = makeStyles({
  container: {
    width: '100%',
    flexBasis: '0%',
    display: 'flex',
    flexGrow: '0',
    justifyContent: 'flex-end',
    ...shorthands.gap('5px'),
  },
  button: {
    width: 'fit-content',
    justifyContent: 'flex-end',
    minWidth: '35px',
    ...shorthands.padding('0px'),
  },
  assetContainerFilterButton: {
    flexBasis: '0%',
    flexGrow: 1,
  },
  buttonText: {
    ...shorthands.overflow('hidden'),
    lineBreak: 'anywhere',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  assetGroup: {
    alignItems: 'center',
    display: 'flex',
  },

  assetContainerText: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginLeft: '3px',
  },
  icon: {
    width: '14px',
    height: '14px',
  },
  assetContainer: {
    '& span:first-child': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
    },
  },
  viewAll: {
    color: '#115EA3',
  },
});
